/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { StyledAnchor }              from '../StyledAnchor';
import { Colours, Spacing, Borders } from '../../../styles/variables';
import { Media }                     from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledNavigationAnchor = StyledAnchor.extend`
  padding: ${Spacing.Small} 0;
  display: block;
  font-weight: 700;
  text-align: center;
  position: relative;
  ${Media.Tablet`
    padding: 2px 0 0;
    border-bottom: 3px solid transparent;
    display: inline-block;
    width: auto;
    color: ${props => props.theme.TabletColor || Colours.Tundora};
    &:hover,
    &.active {
      text-decoration: none;
      border-color: currentColor;
    }
    &[target='_blank'] {
      padding: ${Spacing.Tiny};
      border-color: currentColor;
      border-width: 2px;
      border-style: solid;
      border-radius: ${Borders.Radius};
      white-space: nowrap;
      &:hover {
        border-color: ${Colours.Carnation};
        color: ${Colours.Carnation};
        text-decoration: none;
      }
    }
 `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledNavigationAnchor/index.js